import React, { useEffect, useMemo, useState } from 'react';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import makeStyles from 'housecall-ui/dist/DesignSystem/Styles/makeStyles';
import AddIcon from 'housecall-ui/dist/IconsAndImages/Icons/Add';
import RemoveIcon from 'housecall-ui/dist/IconsAndImages/Icons/Remove';
import { debounce } from 'lodash-es';

const useStyles = makeStyles((theme) => ({
  count: {
    margin: theme.spacing(0, 1),
    fontSize: 16,
    bottom: 6,
  },
  button: {
    minWidth: 0,
  },
}));

type Props = {
  hasPermissions?: boolean;
  initialValue: number;
  minimumValue: number;
  debounceTimeMsec?: number;
  onChange: (newValue: number) => void;
};

const IncrementDecrement = (props: Props) => {
  const { initialValue, minimumValue, onChange, debounceTimeMsec = 500, hasPermissions } = props;

  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = useMemo(() => debounce(onChange, debounceTimeMsec), [onChange, debounceTimeMsec]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const isNotAllowed = hasPermissions === false;

  return (
    <Grid item>
      <Box display="flex" justifyContent="flex-end" alignItems="center">
        <Button
          color="secondary"
          size="small"
          aria-label="remove"
          disabled={value === minimumValue || isNotAllowed}
          className={classes.button}
          data-testid="increment-decrement-minus-button"
          onClick={() => {
            const newValue = Math.max(value - 1, 0);
            handleChange(newValue);
            setValue(newValue);
          }}
        >
          <RemoveIcon />
        </Button>
        <span className={classes.count} data-testid="increment-decrement-value">
          {value}
        </span>
        <Button
          color="primary"
          disabled={isNotAllowed}
          size="small"
          aria-label="add"
          className={classes.button}
          data-testid="increment-decrement-plus-button"
          onClick={() => {
            const newValue = value + 1;
            handleChange(newValue);
            setValue(newValue);
          }}
        >
          <AddIcon />
        </Button>
      </Box>
    </Grid>
  );
};

export default IncrementDecrement;
